import Mention from './Mention';
import { actions, state } from "../../store/Store";
import { Widget as ImpWidgetTpl,Widget_NW as ImpNWidgetTpl, Widget_NW2 as ImpNWidgetTpl2, Aspects_Widget as ImpAWidgetTpl ,Aspects as AspectsTpl } from '../../Templates';
import EventBus from "../../EventBus";
import { reportGAEvents } from "../../services/GAEvents";
import { initLightGallery, isMobile, throttle } from "../../Utils";


let WidgetTpl = actions.mergeTemplates(ImpWidgetTpl, 'Carousel');
let NewWidgetTpl = actions.mergeTemplates(ImpNWidgetTpl, 'Carousel');
let NewWidgetTpl2 = actions.mergeTemplates(ImpNWidgetTpl2, 'Carousel');
let AWidgetTpl = actions.mergeTemplates(ImpAWidgetTpl, 'Carousel');
let Aspects = actions.mergeTemplates(AspectsTpl, 'Carousel');

class Widget extends Product {
	constructor(kpData, options, appEvents) {
		super(kpData, options, Mention, appEvents);

		this.IsOpen = false;
		this.ShownOnce = false;

		if (options.widgetOptions.newDesign) {
			this.Template = NewWidgetTpl;
		}
		else if (options.widgetOptions.newDesign2) {
			this.Template = NewWidgetTpl2;
		}
		 else {
			this.Template = WidgetTpl;
		}


		if (options.widgetOptions.aspects_widget) this.Template = AWidgetTpl;
		if (options.widgetOptions.aspects) this.Template = Aspects;

		this.isAutoPlay = options.autoplay;
		this.AppEvents.subscribe("anchorClicked", (e, data) => {
			//console.log('ee',e)
			//consol e.log('data',data)
			//if (options.widgetOptions.newDesign2)	e.stopPropagation();
			this.openWidget();
		});
		// if (options.widgetOptions.newDesign2) this.AppEvents.subscribe("ratingsAnchorClicked", (e, data) => {
		
		// 	this.openWidget();
		// });
		
		let renderWidgetMentions = (e, AppElm) => {
			let productElm = AppElm.querySelector(".productElm");
			this.AfterCreate(productElm);

			this.RenderMentions()
				.then(() => {
					if (options.autoplay) {
						this.QueuedToPlay = this.Mentions[0];
						this.PlayQueued();
					}
					this.InitWidgetScroll();
				});
		};
		this.AppEvents.subscribe("appUpdated", renderWidgetMentions);

		EventBus.$on("widgetBackClicked", e => {
			this.closeWidget();
		});

		this.AppEvents.subscribe("mainJsonLoaded", (e, KpData) => {
			this.KpData = KpData;
			this.MentionsData = KpData.Data;
			this.SetMentions(KpData.Mentions);

			// this.setMentionsWrapperHeight();
			renderWidgetMentions(e, this.AppElm);
			this.boundaries = this.Elm.getBoundingClientRect();
		});
	}

	AfterCreate(elm) {
		if (!this.Elm) {
			this.AppElm = elm.closest(`.${this.AppClass}`);

			this.DragZone = this.AppElm.querySelector('.dragZone');
			if (this.DragZone && !isMobile()) this.bindDrag();

			this.closeBtn = this.AppElm.querySelector('.close_widget');
			this.closeBtn.onclick = () => {
				this.closeWidget();
			};

			this.setWidgetStyle();
		}

		this.Elm = elm;
	}

	get AppClass() {
		return "fl_widget";
	}

	get Mentions() {
		return this._mentions || [];
	}

	set Mentions(newVal) {
		if (newVal !== this._mentions) {
			this._mentions = newVal;
		}
	}

bindDrag() {
    let moveWidget = throttle((e) => {
        e.stopPropagation();

        if (isDragging && e.clientX !== 0 && e.clientX !== lastClientX && e.clientY !== 0 && e.clientY !== lastClientY) {
            offsetX = e.clientX - dragStartX;
            offsetY = e.clientY - dragStartY;
            lastClientX = e.clientX;
            lastClientY = e.clientY;
            this.AppElm.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
        }
    }, 50);

    function stopDragging() {
        if (!isDragging) return; // Exit if not dragging

        isDragging = false;
        this.widgetBack.removeEventListener("mousemove", moveWidget);
        this.Elm.removeEventListener("mousemove", moveWidget);
        this.PlayQueued();
    }

    let isDragging = false;
    let dragStartX, dragStartY, offsetX = 0, lastClientX, offsetY = 0, lastClientY;

    this.DragZone.addEventListener("mousedown", (e) => {
        dragStartX = e.clientX - offsetX;
        dragStartY = e.clientY - offsetY;
        isDragging = true;

        // Stop current playing video to improve visual performance.
        this.StopAndQueueToPlay();

        // Add event listener when the mouse is moving too quick outside the dragging zone into the below elements123.
        this.widgetBack.addEventListener("mousemove", moveWidget);
        this.Elm.addEventListener("mousemove", moveWidget);
    });

    this.DragZone.addEventListener("mouseup", (e) => {
        stopDragging.call(this);
    });

    this.DragZone.addEventListener("mousemove", moveWidget);

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" || e.keyCode === 27) {
            stopDragging.call(this);
        }
    }, true);

    // Ensure multiple listeners aren't set
    if (!this._initializedDragListeners) {
        // Listen to mouseup on the entire document:
        document.addEventListener("mouseup", (e) => {
            stopDragging.call(this);
        });

        // Listen to mouse out on the entire document
        document.addEventListener("mouseout", (e) => {
            // Check if we're actually leaving the document
            if (!e.relatedTarget && !e.toElement) {
                stopDragging.call(this);
            }
        });

        this._initializedDragListeners = true; // Set flag to indicate listeners are set
    }
}




	setWidgetStyle() {
		if (!this.anchorElm) {
			this.setWidgetStyle();
			return;
		}

		let options = this.Options.widgetOptions;
		let widgetWidth = options.width;
		let widgetHeight = options.height;
		let windowHeight = window.innerHeight;
		this.anchorBoundaries = this.anchorElm.getBoundingClientRect();

		if (windowHeight < widgetHeight) widgetHeight = windowHeight;

		let widgetTop = ((windowHeight - widgetHeight) / 2) + window.pageYOffset + options.offsetTop;

		// if the widget bottom offset is lower than the window bottom,
		// pin it to limit bottom of the window for not making over scroll space.
		if (document.body.scrollHeight < widgetTop + widgetHeight) {
			widgetHeight = windowHeight;
			widgetTop = document.body.scrollHeight - widgetHeight;
		}

		let widgetLeft = 0;
		let widgetTransform = "none";

		if (options.position === "center") {
			widgetLeft = "50%";
			widgetTransform = "translateX(-50%)";
		} else {
			widgetLeft = this.anchorBoundaries.left + window.pageXOffset + this.anchorBoundaries.width + (-1 * options.offsetRight);
			// if there is no room for the widget from the anchor right open it from the anchor's left.
			let offsetLeftFix = 80; // adding 80px offset so the widget won't be too close to the end of the screen.
			if ((widgetLeft + widgetWidth + offsetLeftFix) > window.innerWidth) {
				widgetLeft = this.anchorBoundaries.left - widgetWidth + options.offsetRight;
			}
			widgetLeft += "px";
		}

		this.AppElm.style.width = widgetWidth + "px";
		this.AppElm.style.height = widgetHeight + "px";
		this.AppElm.style.top = widgetTop + "px";
		this.AppElm.style.left = widgetLeft;
		this.AppElm.style.transform = widgetTransform;
				if (this.Options.referrer === 'widget-new-goglobal.co.il') {
							const sourceEl = document.querySelector('.fl_app');      // the element you want to measure
//const targetEl =this.AppElm; // the one you�ll move

// 2. Get its distance from the top of the *document*
const sourceRect = this.anchorElm.getBoundingClientRect();
const scrollY   = window.pageYOffset || document.documentElement.scrollTop;
const sourceTop = sourceRect.top + scrollY;

this.AppElm.querySelector('.fl_app').style.top  = sourceTop + 'px';

				  }
		
	}

	openWidget() {
		let anchorBoundaries = this.anchorElm.getBoundingClientRect();
		if (this.anchorBoundaries && (anchorBoundaries.top !== this.anchorBoundaries.top || anchorBoundaries.left !== this.anchorBoundaries.left)) {
			this.setWidgetStyle();
		}

		if (!this.widgetBack) this.widgetBack = document.querySelector('.fl_widget_back');
		this.widgetBack.style.display = 'block';

		if (!this.ShownOnce) {
			reportGAEvents('interacted', this.KeyPhrase);
		}

		// if the widget is first time inserted to the page we need to wait 200ms for the html to be rendered
		this.AppElm.className += " active";
		this.IsOpen = true;

		reportGAEvents('show', this.Phrase);

		let scoreElm = this.AppElm.querySelector(".appHeader .score");
		scoreElm.className += ' animate-pop';
		setTimeout(() => {scoreElm.className = scoreElm.className.replace(' animate-pop', '')}, 500);

		setTimeout(() => {
			if (!this.ShownOnce) {
				reportGAEvents('shown once', this.Phrase);
				this.ShownOnce = true;
			}
			else {
				// Play the last paused video when the widget was closed.
				// first let the score animation finish from visual performance aspects.
				setTimeout(() => {this.PlayQueued()}, 800);
			}
		}, 100);
	}

	closeWidget() {
		if (!this.IsOpen) return;
		this.widgetBack.style.display = 'none';
		this.AppElm.className = this.AppElm.className.replace("active", "");
		this.IsOpen = false;

		// pause all videos when the widget is closed.
		this.StopAndQueueToPlay();
	}

	InitWidgetScroll() {
		this.Scroller = new SimpleBar(this.Elm, {
			scrollbarMinSize: 40
		});

		if (this.isAutoPlay) {
			this.Scroller.getScrollElement().addEventListener('scroll', throttle((e) => {
				let visibleVideos = {};
				this.Mentions.forEach((mention) => {
					if (!mention.Elm) return;
					let mentionBoundaries = mention.Elm.getBoundingClientRect();
	
					let hiddenPercentage = Math.round((Math.abs(mentionBoundaries.top - this.boundaries.top) / mentionBoundaries.height) * 100);
					mention.HiddenPercentage = hiddenPercentage;
					mention.IsVisible = (hiddenPercentage >= 0 && hiddenPercentage < 80);
					if (mention.IsVisible && mention.hasVideo) {
						visibleVideos[hiddenPercentage] = mention;
					}
					else if (!mention.IsVisible && mention.Player) {
						mention.Player.pause();
					}
				});
	
				let videoPlayed = false;
				for (let percent in visibleVideos) {
					let mention = visibleVideos[percent];
					if (!videoPlayed) {
						// play the video only if it didn't initialize or
						// if it's not already playing or the video has ended.
						if (!mention.Player || (mention.Player && !mention.Player.IsPlaying)) mention.AutoplayVideos();
						videoPlayed = true;
					}
					else if (videoPlayed && mention.Player) {
						mention.Player.pause();
					}
				}
			}, 1000));
		}
	}

	render() {
		let Tpl = this.Template.str;
		let data = {
			components: {
				mentions: []
			}
		};

		return doT.template(Tpl)(data);
	}
}

export default Widget


// WEBPACK FOOTER //
// ./src/app/components/widget/Widget.js